// extracted by mini-css-extract-plugin
export default {"content":"BlogCard_content__vSyWi"};